import { render, staticRenderFns } from "./endorse-housemaid-policy-form.vue?vue&type=template&id=c6959310&"
import script from "./endorse-housemaid-policy-form.vue?vue&type=script&lang=js&"
export * from "./endorse-housemaid-policy-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports